/*------------------------------------*\
    $GLOBAL VARIABLES
\*------------------------------------*/
var $html = jQuery( 'html' ),
    $body = jQuery( 'body' ),
    $win  = jQuery( window ),
    $doc  = jQuery( document ),
    $t    = jQuery( this );

var is_phone,
	touch,
	ltie9,
	lteie9,
	wh, ww,
	dh, ar,
	ieMobile,
    ua = navigator.userAgent;

var is_webkit 		= ua.match(/webkit/i);
var is_firefox 		= ua.match(/gecko/i);
var is_newer_ie 	= ua.match(/msie (9|([1-9][0-9]))/i);
var is_older_ie 	= ua.match(/msie/i) && !is_newer_ie;
var is_ancient_ie 	= ua.match(/msie 6/i);
var is_mobile		= ua.match(/mobile/i);
var is_OSX 			= ( ua.match(/(iPad|iPhone|iPod|Macintosh)/g) ? true : false );
var is_android 		= ( ( ua.indexOf( 'Mozilla/5.0' ) > -1 && ua.indexOf( 'Android ' ) > -1 && ua.indexOf( 'AppleWebKit' ) > -1) && ! ( ua.indexOf( 'Chrome' ) > -1 ) );


/**
 * This is useful if you want to review all notices in the console.
 *
 * Set it to true if you want debug the code!
 */
var debug = false;

/*------------------------------------*\
    $APP.JS
\*------------------------------------*/
(function( $, window, undefined ) {
	"use strict";

	/**
	 *  DETECT VIEWPORT SIZE
	 */
	function browserSize() {
		wh = $win.height();
		ww = $win.width();
		dh = $doc.height();
		ar = ww/wh;
	}


	/**
	 *  DETECT PLATFORM
	 */
	function platformDetect() {

		$.support.touch = 'ontouchend' in document;

		var navUA = navigator.userAgent.toLowerCase(),
			navPlat = navigator.platform.toLowerCase();

		var is_iPhone = navPlat.indexOf('iphone'),
			is_iPod = navPlat.indexOf('ipod'),
			is_AndroidPhone = navPlat.indexOf('android'),
			is_safari = ( navUA.indexOf('safari') != - 1 && navUA.indexOf('chrome') == - 1 ) ? true : false,
			svgSupport = ( window.SVGAngle ) ? true : false,
			svgSupportAlt = ( document.implementation.hasFeature('http://www.w3.org/TR/SVG11/feature#BasicStructure', '1.1') ) ? true : false;

		is_phone = ( is_iPhone > - 1 || is_iPod > - 1 || is_AndroidPhone > - 1 ) ? true : false;
		touch = $.support.touch ? true : false;
		ltie9 = $.support.leadingWhitespace ? false : true;
		lteie9 = typeof window.atob === 'undefined' ? true : false;

		ieMobile = navigator.userAgent.match(/Windows Phone/i) ? true : false;

		if ( touch || ieMobile ) {
			$html.addClass( 'touch' );
		}

		if ( is_safari ) $html.addClass('safari');
		if ( is_phone ) $html.addClass('phone');

	}


	function init() {
		if (debug) {console.group("Init");}

		/**
		 * $GET BROWSER DIMENSIONS
		 */
		browserSize();

		/**
		 * $DETECT PLATFORM
		 */
		platformDetect();


		/**
		 * $INSTANTIATE DJAX
		 *
		 * When an image finished loaded add class to parent for
		 * the image to fade in
		 */
		if ( $('body').data('ajaxloading') !== undefined ) {

			var djax_transition = function ( $newEl ) {
				if ( debug ) {console.group("djax Transition");}

				var $oldEl = this;
				$oldEl.replaceWith($newEl);

				// we should make sure initial transition ended
				setTimeout(function () {
					$('html').removeClass('loading');
				});

				if ( debug ) {console.groupEnd();}
			};

			$('body').djax('.djaxable', [ '.pdf', '.doc', '.eps', '.png', '.zip', 'admin', 'wp-', 'wp-admin', 'feed', '#', '?lang=', '&lang=', '&add-to-cart=', '?add-to-cart=', '?remove_item' ], djax_transition);

		}

		if (debug) {console.groupEnd();}
	}


	/**
	 * $ADD LOADED CLASS
	 *
	 * Add loaded class before initialize
	 */
	$('html').addClass('loaded');


	/**
	 * $ON DOCUMENT READY
	 */
	$(function () {
		if (debug) {console.group("OnDocumentReady");}

		// Initialize
		init();

		// Load all scripts
		loadScripts();

		if (debug) {console.groupEnd();}
	} );


	/**
     * $LAZY LOADING INIT
     *
     * When an image finished loaded add class to parent for
     * the image to fade in
     */
    function lazyLoad() {

		if ( $('#article').data('lazyload') !== undefined ) {

			var $images = $('img[data-unveil="true"]');

			$images.each(function () {

				var self = $(this);

				self.unveil(0, function () {

					self.addClass('is-loaded');

				});

			});

		}

    };


    /**
     * $ON WINDOW LOAD
     *
     * When an image finished loaded add class to parent for
     * the image to fade in
     */
    $win.load( function() {
        if (debug) {console.group('OnWindowLoad');}

        lazyLoad();

		$('html').removeClass('loading');

        if (debug) {console.groupEnd();}
    } );


	/**
	 * $ON WINDOW SCROLL
	 */
	$win.scroll( function() {
		handleStickyClass();
	});

	/**
	 * $ON RESIZE
	 */
	$win.on("debouncedresize", function( e ) {

		browserSize();

		if ( ww < 901 ) {
			$('html').removeClass('nicescroll');
			$('[data-smoothscrolling]').getNiceScroll().hide();
		} else {
			niceScrollInit();
		}

	});

	/**
	 * $HAMBURGER MENU
	 */
	$('#hamburger .lavanta-tabs').click( function() {

		$(this).toggleClass('open');

	} );


	/**
	 * $CHECK OF THE NAVBAR ELEMENTS FIT THE CONTAINER
	 *
	 * When a link doesn't fit the content it will get a class
	 * named is--not-fitting. This can be used for animation.
	 */
	$('body.compact .navbar-nav a').each( function() {

		var self = $(this);

		if ( self.prop('scrollWidth') > self.width() ) {

			self.parent().addClass('is--not-fitting');

		}

	});

	/**
	 * $REMOVE EMPTY PARAGRAPHS
	 */
	function removeEmptyParagraphs() {

		$('p:empty').remove();

		$('p').each(function () {

			var self = $(this);

			if ( self.html().replace(/\s|&nbsp;/g, '').length == 0 ) {
				self.remove();
			}

		});
	}

	/**
	 * $LOAD ALL SCRIPTS
	 *
	 * We will run all scripts before initialize
	 */
	function loadScripts() {

		// Nicescroll
		niceScrollInit();

		// Get Disqus thread
		disqusThread();

		// Bookmark script
		bookmarker();

		// Run gist script
		$('[data-gist-id]').gist();

		// Fit the iframes, objects etc. Aspect ratio problems solved.
		$(".start-reading").fitVids();

		// Click/scroll event for comment section
		commentButton();

		// Add noanims class after 1000ms
		noanims();

		// Run headroom for actions in single post
		actionsHeadroom();

		// Handle sticky header
		handleStickyClass();

		// Animate blog one by one
		animateBlog('in');

		// Animate all gallery elements in
		animateBlogRandomly('in');

		// Matric effect for meta cover
		matrixEffect();

		// Remove empties
		removeEmptyParagraphs();

		// Read now link
		setReadMore();

		// Share
		shareButton();

	}

	/**
	 * $SHARE BUTTON
	 */
	function shareButton() {

		$('.share-button').click(function () {
			$(this).parent().find('.share-links .share-links-inner').fadeToggle(300, 'linear');
		});

	}

	/**
	 * $ON SCROLL HANDLE STICKY CLASS
	 *
	 * When scroll defined add the class is_stuck
	 * into the header-inner so we can give a effect below it.
	 */
	function handleStickyClass() {

		var offsetTop = 0,
			scrollTop = $win.scrollTop(),
			$get = $('.header'),
			$set = 'is_stuck';

		if ( scrollTop > offsetTop ) {
			$get.addClass($set);
		} else {
			$get.removeClass($set);
		}

		// If header sticky
		if ( $get.data('sticky') !== undefined ) {

			if ( scrollTop > 50 ) {

				// Headroom init
				$get.find('.header-inner').headroom({
					// specify tolerance individually for up/down scroll
					tolerance: {
						up: 5,
						down: 5
					},
					// css classes to apply
					classes: {
						// when element is initialised
						initial: "slide",
						// when scrolling up
						pinned: "slide--pinned",
						// when scrolling down
						unpinned: "slide--unpinned",
						// when above offset
						top: "slide--top",
						// when below offset
						notTop: "slide--not-top"
					},
				});

			}

		}

	}


	/**
	 * $MATRIX EFFECT
	 *
	 * Effect for meta cover
	 */
	function matrixEffect() {

		function effect( a ) {

			var b = (- a.pageX + d) / d * e,
				g = (a.pageY - c) / c * f;

			b > e && (b = e), - e > b && (b = - e), g > f && (g = f), - f > g && (g = - f), TweenLite.to(h, .8, {
				rotationX: g,
				rotationY: b,
				ease: Power2.easeOut
			});

		}

		var c = .5 * $win.height(),
			d = .5 * $win.width(),
			e = 8,
			f = 5,
			g = $(".content-alignment .meta-content"),
			h = g;


		if ( $('.meta-cover .content').data('matrix') !== undefined ) {

			g.on("mousemove", function ( c ) {
				$("html").hasClass("csstransforms3d") && $("body").hasClass("home") && window.requestAnimationFrame(function () {
					effect(c);
				})
			}), $win.on("resize", function () {
				$("html").hasClass("csstransforms3d") ? window.requestAnimationFrame(function () {
					c = .5 * $(window).height(), d = .5 * $(window).width()
				}) : (g.attr("style", ""), h.attr("style", "").removeClass("is-absolute"));
			});

		}

	}



	/**
	 * $DISQUS
	 *
	 * Great discussions are happening here. Whether it's the biggest
	 * story of the day or the kind of thing super fans are talking
	 * about, there's lots to discuss on Disqus.
	 */
	function disqusThread() {

		if ( $('#disqus_thread').data('shortname') !== undefined && $body.hasClass('single') ) {

			var disqus_shortname = $('#disqus_thread').data('shortname');

			/*** DON'T EDIT BELOW THIS LINE ***/
			(function () {
				var dsq = document.createElement('script');
				dsq.type = 'text/javascript';
				dsq.async = true;
				dsq.src = '//' + disqus_shortname + '.disqus.com/embed.js';
				(document.getElementsByTagName('head')[ 0 ] || document.getElementsByTagName('body')[ 0 ]).appendChild(dsq);
			})();


		}

	}

	/**
	 * $BOOKMARK
	 *
	 * Cross-Browser jQuery Bookmark Script
	 */
	function bookmarker() {

		$('.bookmark-link').on('click', this, function ( e ) {

			e.preventDefault();

			var bookmarkURL = $(this).data('href');
			var bookmarkTitle = $(this).data('title');

			try {

				if ( window.sidebar && window.sidebar.addPanel ) { // Mozilla Firefox Bookmark
					window.sidebar.addPanel(document.title, window.location.href, '');
				} else if ( window.external && ('AddFavorite' in window.external) ) { // IE Favorite
					window.external.AddFavorite(location.href, document.title);
				} else if ( window.opera && window.print ) { // Opera Hotlist
					this.title = document.title;
					return true;
				} else { // webkit - safari/chrome

					swal({
						title: "Bookmark",
						text: 'Press ' + (navigator.userAgent.toLowerCase().indexOf('mac') != - 1 ? '<strong style="color:#F8BB86">Command/Cmd</strong>' : '<strong style="color:#F8BB86">CTRL</strong>') + ' <strong style="color:#F8BB86">+ D</strong> to bookmark this page.',
						type: "info",
						showCancelButton: true,
						closeOnConfirm: false,
						timer: 4500,
						showLoaderOnConfirm: true,
						html: true
					});

				}

			} catch ( err ) { // catch all incl webkit
				sweetAlert("Oops...", "Your browser does not support this bookmark action. Please bookmark this page manually!", "error");
			}

		} );

	}



	/**
	 * $COMMENT RESPOND
	 *
	 * Animate to the bottom of the respond area
	 */
	function commentButton() {

		$('.comment-button').on('click', function () {

			var respond = $('.entry__comments'),
				animSpeed = 300;

			$('html, body').stop().animate({
				scrollTop: respond.offset().top
			}, animSpeed);

		});

	}

	/**
	 * $NICESCROLL INIT
	 */
	function niceScrollInit() {

		var smoothScroll = $('body').data('smoothscrolling') !== undefined;

		if ( smoothScroll && ww > 899 && ! touch && ! is_OSX ) {
			$('html').addClass('nicescroll');
			$('[data-smoothscrolling]').niceScroll({
				zindex: 9999,
				cursoropacitymin: 0.3,
				cursorwidth: 7,
				cursorborder: 0,
				mousescrollstep: 40,
				scrollspeed: 100,
				cursorcolor: '#363732'
			});
		}

	}


	/**
	 * $ADD NOANIMS CLASS
	 *
	 * We will add no anim class to the html tag.
	 * So we can remove perspectiveness in CSS3.
	 */
	function noanims() {

		setTimeout( function() {
			$('html').addClass('noanims');
		}, 2500 );

	}


	/**
	 * $HEADROM ACTIONS
	 *
	 * You can here define more headroom actions.
	 *
	 * @TODO: When Mousemove to the bottom of the page - show actions elements
	 */
	function actionsHeadroom() {

		// Check if sticky headroom exist
		if ( $('.single .entry__actions').data('sticky') !== undefined ) {

			/**
			 * Content variable
			 * @type {*|HTMLElement}
			 */
			var content = $('.single .single__content');

			// Waypoint init
			content.waypoint( {
				handler: function( direction ) {
					content.toggleClass('bottom--reached');
				},
				offset: 'bottom-in-view'
			} );

			/**
			 * Actions variable
			 * @type {*|HTMLElement}
			 */
			var actions = $(".single .entry__actions");

			// Headroom init
			setTimeout( function() {

				actions.headroom({
					// specify tolerance individually for up/down scroll
					tolerance : {
						up : 15,
						down : 5
					},
					// css classes to apply
					classes: {
						// when element is initialised
						initial: "slide",
						// when scrolling up
						pinned: "slide--pinned",
						// when scrolling down
						unpinned: "slide--unpinned",
						// when above offset
						top: "slide--top",
						// when below offset
						notTop: "slide--not-top"
					},
				});

			}, 3000);

			// Unpin element when stopped with scrolling
			content.on( 'DOMMouseScroll mousewheel', function() {

				clearTimeout( $.data( this, "scrollCheck" ) );

				$.data( this, "scrollCheck", setTimeout( function() {

					actions.addClass('slide--unpinned');

				}, 4000) );

			});

			// Headroom unpin after 9s
			setTimeout( function() {
				actions.addClass('slide--unpinned');
			}, 9000 );

			// Hover detection
			actions.on("mouseenter", function () {
				$(this).addClass("is--hover");
			}).on("mouseleave", function () {
				setTimeout(function () {
					actions.removeClass("is--hover");
				}, 2500);
			});

		}

	}

	/**
	 * Animate blog items randomly
	 */
	function animateBlogRandomly( direction ) {
		if (debug) {console.log("Animate Gallery " + direction);}

		direction = direction == "in" ? direction : "out";

		if ( $('.post-listing').data('random') !== undefined ) {

			$('.post-listing .post-item').each(function () {
				var self = $(this);

				setTimeout(function () {
					self.addClass('is-slide' + direction);
				}, 80 * Math.floor((Math.random() * 5) + 1));

			});
		}

	}

	/**
	 * Read now link for single blog
	 */
	function setReadMore(){

		var $main = $('#main'),
			$htmlBody = $('html, body');

		$main.find('.read-now-link').click(function(){

			var destination = $main.find('#article').offset().top;

			if ( ! $body.hasClass('logged-in') ) {
				$htmlBody.animate({ scrollTop: destination - 18}, 450);
			} else {
				$htmlBody.animate({ scrollTop: destination - 50}, 450);
			}

			return false;

		});
	}



	/**
	 * Animate blog items one by one
	 * @param direction
	 */
	function animateBlog(direction) {
		if (debug) {console.log("Animate Blog " + direction);}

		if ( ! is_android ) {

			if ( $('.post-listing').data('onebyone') !== undefined ) {

				direction = direction == "in" ? direction : "out";

				var sizes = new Array();
				var columns = new Array();
				var items = $('.post-listing .post-item').length;

				$('.post-listing').each(function ( i, e ) {
					columns[ i ] = $(this).children('.post-item');
					sizes[ i ] = columns[ i ].length;
				});

				var max = Math.max.apply(null, sizes);

				for ( var item = 0; item < max; item ++ ) {

					$(columns).each(function ( column ) {

						if ( columns[ column ][ item ] !== undefined ) {

							if ( direction == "in" ) {

								var $item = $(columns[ column ][ item ]),
									timeout = item * columns.length + column;

								setTimeout(function () {
									$item.addClass('is-loaded');
								}, 250 * timeout);

							} else {

								var $item = $(columns[ column ][ item ]),
									timeout = items - (item * columns.length + column);

								setTimeout(function () {
									$item.removeClass('is-loaded');
								}, 100 * timeout);
							}
						}
					});
				}
			}

		}
	}

	/**
	 * $ON DJAX REQUESTD
	 */
	$(window).bind('djaxClick', function(e, data) {
		if (debug) {console.group("On-dJaxClick");}

		$('html').removeClass('noanims');

		$('html').addClass('loading');

		$('html, body').animate({ scrollTop: 0 }, 300);



		/* --- ANIMATE STUFF OUT --- */
		animateBlogRandomly('out');
		animateBlog('out');

		if (debug) {console.groupEnd();}
	});

	/**
	 * $ON DJAX LOAD
	 */
	$(window).bind('djaxLoad', function(e, data) {
		if (debug) {console.group("On-dJaxLoad");}

		// get data and replace the body tag with a nobody tag
		// because jquery strips the body tag when creating objects from data
		data = data.response.replace(/(<\/?)body( .+?)?>/gi, '$1NOTBODY$2>', data);

		// get the nobody tag's classes
		var nobodyClass = $(data).filter('notbody').attr("class");

		// set it to current body tag
		$('body').attr("class", nobodyClass);

		// let the party begin
		$('html').removeClass('loading');

		browserSize();

		lazyLoad();

		/**
		 * Rerun load script after djaxLoad
		 */
		loadScripts();


		// Lets do some Google Analytics Tracking
		if (window._gaq) {
			_gaq.push(['_trackPageview']);
		}

		if (debug) {console.groupEnd();}
	});


})(jQuery, window);